import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';


export function fetchYearInfo(payload) {
  return { type: actionTypes.FETCH_YEAR_INFO, payload };
}

export function fetchYearInfoSuccess(payload) {
  console.log('Year info success..............', payload)
  const byId = keyBy(payload, (yearinfo) => (yearinfo.STUDENT_NUMBER ? yearinfo.STUDENT_NUMBER : ''));
  return { type: actionTypes.FETCH_YEAR_INFO_SUCCESS, payload: { byId } };
}